/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import PropTypes from 'prop-types';
import { __ } from '@googleforcreators/i18n';
import { Text, TextSize } from '@googleforcreators/design-system';

/**
 * Internal dependencies
 */
import Dialog from '../dialog';

function PreviewErrorDialog({ isOpen, onClose, onRetry }) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={__('Open preview', 'web-stories')}
      secondaryText={__('Cancel', 'web-stories')}
      onPrimary={onRetry}
      primaryText={__('Try again', 'web-stories')}
    >
      <Text.Paragraph size={TextSize.Small}>
        {__('The preview window failed to open.', 'web-stories')}
      </Text.Paragraph>
    </Dialog>
  );
}

PreviewErrorDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
};

export default PreviewErrorDialog;
